"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var ShopOptions_1 = require("./ShopOptions");
var ShopPurchaseTypes_1 = require("./ShopPurchaseTypes");
var ShopQuantities_1 = require("./ShopQuantities");
var ShopContext_1 = require("./ShopContext");
var hooks_1 = require("preact/hooks");
var ShopSelections = function () {
    var _a, _b;
    var _c = (0, hooks_1.useContext)(ShopContext_1.default), singleProductBundle = _c.singleProductBundle, optionIndex = _c.optionIndex, options = _c.options, purchaseTypeIndex = _c.purchaseTypeIndex;
    var selectionsStack = [];
    var optionsCount = options.length;
    var stackIndex = 1;
    if (optionsCount >= 2) {
        selectionsStack.push((0, preact_1.h)(ShopOptions_1.default, { stackIndex: stackIndex++ }));
    }
    var purchaseTypeCount = (_a = options[optionIndex].purchaseTypes) === null || _a === void 0 ? void 0 : _a.references.nodes;
    if (purchaseTypeCount && purchaseTypeCount.length >= 2) {
        selectionsStack.push((0, preact_1.h)(ShopPurchaseTypes_1.default, { stackIndex: stackIndex++ }));
    }
    if (((_b = options[optionIndex].purchaseTypes) === null || _b === void 0 ? void 0 : _b.references.nodes[purchaseTypeIndex].products.references.nodes.length) === 3 ||
        singleProductBundle) {
        selectionsStack.push((0, preact_1.h)(ShopQuantities_1.default, { stackIndex: stackIndex++ }));
    }
    return (0, preact_1.h)("div", { class: "shop-v2__selections" }, selectionsStack);
};
exports.default = ShopSelections;
